import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorksMaterialProductionRateNorms(options = {}) {
	
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
		options
	)
}

function _createWorksMaterialProductionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].CREATE_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
		options
	)
}

function _getWorksMaterialProductionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
		options
	)
}

function _patchWorksMaterialProductionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].PATCH_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
		options
	)
}

function _putWorksMaterialProductionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].PUT_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
		options
	)
}

function _deleteWorksMaterialProductionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].DELETE_WORKS_MATERIAL_PRODUCTION_RATE_NORM,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORMS]: _getWorksMaterialProductionRateNorms,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].CREATE_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: _createWorksMaterialProductionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].GET_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: _getWorksMaterialProductionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].PATCH_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: _patchWorksMaterialProductionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].PUT_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: _putWorksMaterialProductionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].DELETE_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: _deleteWorksMaterialProductionRateNorm,
}